export default __webpack_public_path__ + "static/media/solving.c01f81fb.svg";